<template>
	<div id="user-access-page" class="placed-backg">
		<div class="container">
			<div class="row mx-0 flex-center-xy page-size">
				<div class="form-container w-100">
					<div class="box-color">
						<i><u class="fas fa-user"></u></i>
					</div>

					<b-form class="form" @submit.prevent="register">
						<h1 class="mb-3">Registrate como repartidor <span v-if="debug">DEV</span></h1>

						<h5 class="mb-2 f-w-700 txt-green">TUS DATOS</h5>

						<div class="row">
							<template v-for="item in archetype">
								<div class="col-lg-6" :key="item.key" v-if="['hidden', 'imagen'].indexOf(item.type) == -1">
									<b-form-group class="custom-group-s-1" :label="item.label" > 
										<b-form-textarea v-if="item.type == 'textarea'" v-model="form[item.key]" />
										<b-form-input v-else :type="item.type" v-model="form[item.key]"/>
									</b-form-group>
								</div>
							</template>
						</div>

						<div id="AcceptanceToC" class="d-inline-block mb-3">
							<b-form-checkbox v-model="form.tos" name="usertype" value="1" unchecked-value="" required >
								Acepto los términos y condiciones
							</b-form-checkbox>
						</div>

						<p id="LoginLink" class="mb-1">
							<router-link to="/login">
							¿Ya tiene una cuenta?
							</router-link>
						</p>

						<b-form-group class="mt-3">
							<b-button type="submit" class="btn-blue" variant="primary" v-if="!isProcessing">
								Crear una cuenta
							</b-button >
							<b-button disabled class="btn-blue" variant="primary" v-else>
								Procesando...
							</b-button >
						</b-form-group>

						<div class="debug" v-if="debug"><pre>{{form}}</pre></div>
					</b-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash'
import {archetype, formFromArchetype, signupAsRepa} from './repa/archetype'
export default {
	name: 'signupDeliveryBoy',
	props: {
		debug: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			archetype: _.cloneDeep(archetype),
			isProcessing: false,
			form: formFromArchetype()
		};
	},

	methods: {
		async register(evt) {
			if(!this.isProcessing){
				try {
					this.isProcessing = true;
					let response = await signupAsRepa(this.form)
					if(response)
						this.$router.replace('/')
					this.isProcessing = false;
				} catch(e){
					console.error(e)
				}
			}
		},
	},

	mounted() {
	}

};
</script>
